import React, {Fragment}  from 'react';
import styles from './ReportPageLoader.module.scss';

export default function ReportPageLoader(){
    return (
        <div className={styles.reportPageLoader}>
            <GenerateComponents className={styles.horizontal} total={3}>
                <div className={styles.skeleton}></div>
            </GenerateComponents>
            <GenerateComponents className={styles.vertical} total={5}>
                <div className={styles.skeleton}></div>
            </GenerateComponents>
            <GenerateComponents className={styles.single} />
        </div>
    );
}

const GenerateComponents = ({children, className, total}) => {
    return (
        <div className={className || ''}>
            {[...new Array(total || 0)].map((_, i) => <Fragment key={`${i}-key`}>{children}</Fragment>)}
        </div>
    );
};